// frontend/src/utils/timeTrackingService.js
import api from './api';

// ==================== CR/MASTER APIs ====================

// Create a new CR/CM
export const createCR = async (data) => {
    const response = await api.post('/api/time-tracking/cr', data);
    return response.data;
};

// Get all CR/CM for a ticket
export const getCRsByTicket = async (ticketId) => {
    const response = await api.get(`/api/time-tracking/cr/ticket/${ticketId}`);
    return response.data;
};

// Get single CR/CM by ID
export const getCRById = async (id) => {
    const response = await api.get(`/api/time-tracking/cr/${id}`);
    return response.data;
};

// Update CR/CM
export const updateCR = async (id, data) => {
    const response = await api.put(`/api/time-tracking/cr/${id}`, data);
    return response.data;
};

// Delete CR/CM
export const deleteCR = async (id) => {
    const response = await api.delete(`/api/time-tracking/cr/${id}`);
    return response.data;
};

// ==================== TIME ENTRY APIs ====================

// Add a time entry (with CR)
export const addTimeEntry = async (data) => {
    const response = await api.post('/api/time-tracking/time-entries', data);
    return response.data;
};

// ==================== NEW: DIRECT TIME ENTRY APIs (NO CR) ====================

/**
 * Add a time entry directly to a ticket WITHOUT creating a CR
 * @param {Object} data - { ticket_id, entry_date, start_time, end_time, duration, activity_type, resource, description }
 */
export const addDirectTimeEntry = async (data) => {
    const response = await api.post('/api/time-tracking/direct', data);
    return response.data;
};

/**
 * Get ALL time entries for a ticket (both CR-based and direct)
 * @param {number} ticketId - The ticket ID
 */
export const getAllTimeEntriesByTicket = async (ticketId) => {
    const response = await api.get(`/api/time-tracking/ticket/${ticketId}/all`);
    return response.data;
};

// ==================== EXISTING TIME ENTRY APIs ====================

// Get time entries for a specific CR/CM
export const getTimeEntriesByCR = async (crMasterId) => {
    const response = await api.get(`/api/time-tracking/time-entries/cr/${crMasterId}`);
    return response.data;
};

// Get time entries for a ticket (all CR/CMs) - CR only
export const getTimeEntriesByTicket = async (ticketId) => {
    const response = await api.get(`/api/time-tracking/time-entries/ticket/${ticketId}`);
    return response.data;
};

// Update a time entry
export const updateTimeEntry = async (id, data) => {
    const response = await api.put(`/api/time-tracking/time-entries/${id}`, data);
    return response.data;
};

// Delete a time entry
export const deleteTimeEntry = async (id) => {
    const response = await api.delete(`/api/time-tracking/time-entries/${id}`);
    return response.data;
};

// ==================== REPORT APIs ====================

// Get single CR/CM report data
export const getSingleCRReport = async (crMasterId) => {
    const response = await api.get(`/api/time-tracking/report/single/${crMasterId}`);
    return response.data;
};

// Get monthly report data
export const getMonthlyReport = async (ticketId, year, month) => {
    const response = await api.get(`/api/time-tracking/report/monthly`, {
        params: { ticketId, year, month }
    });
    return response.data;
};